'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

import { posthog, isPostHogEnabled } from '@/lib/posthog';

export function PostHogProvider() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!isPostHogEnabled()) return;

    const url =
      pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : '');
    posthog.capture('$pageview', { $current_url: url });
  }, [pathname, searchParams]);

  // Unhandled rejections and global window errors are already captured
  // automatically by posthog-js via `capture_exceptions: true`.
  // Adding manual window listeners here would double-capture those events,
  // creating duplicate issues in PostHog and causing inconsistent Slack alerts.

  return null;
}
